export default __webpack_public_path__ + "static/media/sticker-X.463b76b7.png";